import classnames from 'classnames';
import PropTypes from 'prop-types';

import './style.scss';

const LayerSettingsItem = ({
	title,
	url,
	isLink,
	dangerous,
	disabled,
	onClick,
	children,
	className,
}) => {
	const hoverable = !disabled && (!!onClick || isLink);
	const classes = classnames(
		'ptr-LayerSettingsItem',
		{
			'is-hoverable': hoverable,
			'is-dangerous': dangerous,
			'is-disabled': disabled,
		},
		className,
	);

	const handleKeyDown = event => {
		if (event.key === 'Enter') {
			onClick();
		}
	};

	if (isLink) {
		return (
			<a className={classes} href={url}>
				<div className="ptr-LayerSettingsItem-title">{title}</div>
				<div className="ptr-LayerSettingsItem-control">{children}</div>
			</a>
		);
	} else {
		return (
			<div
				className={classes}
				onClick={onClick}
				tabIndex={hoverable ? 0 : -1}
				onKeyDown={handleKeyDown}
			>
				<div className="ptr-LayerSettingsItem-title">{title}</div>
				{children ? (
					<div className="ptr-LayerSettingsItem-control">{children}</div>
				) : null}
			</div>
		);
	}
};

LayerSettingsItem.propTypes = {
	title: PropTypes.string,
	dangerous: PropTypes.bool,
	disabled: PropTypes.bool,
	isLink: PropTypes.bool,
	onClick: PropTypes.func,
	url: PropTypes.string,
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default LayerSettingsItem;
